import {i18n} from "../i18n";
import {store} from "./mainStore";


const emailSubj = (mail, textKey) => {
	function isNewerVersion (oldVer, newVer) {
		const oldParts = oldVer.split('.')
		const newParts = newVer.split('.')
		for (var i = 0; i < newParts.length; i++) {
		  const a = ~~newParts[i] // parse int
		  const b = ~~oldParts[i] // parse int
		  if (a > b) return true
		  if (a < b) return false
		}
		return false
	  }
	const version = store.osVersion.split(' ')[1];
	const needFix = store.isIOS && !isNewerVersion(version, '14.6') &&isNewerVersion(version, '15.5')

	const logged = [
		store.user.facebook.isConnected && i18n.t('facebook'),
		store.user.halo.isConnected && i18n.t('unity'),
		store.user.siuEmail !== '' && i18n.t('email'),
		store.user.apple.isConnected && i18n.t('apple')
	].filter(Boolean);

	return `mailto:${mail}@deckofdice.com?subject=${encodeURI(i18n.t(textKey))}
		&body=${encodeURI(i18n.t(needFix ? 'email-body-146' : 'email-body')
			.replace('*plrID*', store.user.guest.serverData.UserId)
			.replace('*platform*', store.isIOS ? 'IOS' : 'Android')
			.replace('*device*', store.deviceModel || '')
			.replace('*os*', store.osVersion || '')
			.replace('*country*', store.countryCode || '')
			.replace('*lang*', window.rawLang.toUpperCase() || '')
			.replace('*connect*', store.connectionType || '')
			.replace('*logged*', logged.join(', ') || i18n.t('guest'))
		)}
	`;
}

const remoteFolder = (store.isDev && store.cfgFolder === 'dev') ? '/REMOTE' 
	: ('https://uncached-messages.s3.us-east-2.amazonaws.com/'+ store.cfgFolder);

const SiuConstants = {
	TOS_LINK: 'https://deckofdicegaminginc.com/terms-of-service',
	PP_LINK: 'https://deckofdicegaminginc.com/privacy-policy',
	FAQ_LINK: 'https://gdoc.pub/doc/e/2PACX-1vT9PEzr7nfXahIsrIz_RLFyniSUWATUQ6IPejwihB2tc3QKZ8nZcBLao12ebTgRmC1hGF93lOHONORX',
	SMS_MSG: "send-sms?playerid=*playerid*&number=&body=I'm having fun playing SHAKE IT UP! Dice Poker – install now and LET'S ROLL! 🎲🎉 ", // onelink.to/shakeitupdice",
	// SMS_MSG: "send-sms?&number=&body=I'm having fun playing SHAKE IT UP! Dice Poker – install now and LET'S ROLL! 🎲🎉 ", // onelink.to/shakeitupdice",
	remotePath: remoteFolder + '/SIU',
	eventConfig: remoteFolder + '/SIU/eventsConfig.json',
	promoConfig: remoteFolder + '/SIU/promoConfig.json',
	weekConfig: remoteFolder + '/SIU/weekConfig.json',
	MAIL_TO: () => emailSubj('support', 'email-subj-siu'),

	BUTTON_SCHEME: {
		topShadows: 'inset 0 0 0.75vw 0 topShadowColor',
		bottomShadows: `inset 0 0.25vw 0.5vw 0 bottomShadowColor, 
			0 0.75vw 1.25vw #00000066`,
		blue: {
			bottomGrad: '#3459ab 0%,#2a4a96 15%,#254182 35%,#254182 65%,#2a4a96 85%,#3459ab 100%',
			bottomShadowColor: '#5087d8',
			topGrad: '#6dabff,#3f6ac9',
			topShadowColor: '#a9ceff'
		},
		green: {
			bottomGrad: '#267e22 0%,#276824 15%,#245c21 35%,#245c21 65%,#276824 85%,#267e22 100%',
			bottomShadowColor: '#40ab2e',
			topGrad: '#5adf49,#328c24',
			topShadowColor: '#8fe684'
		},
		grey: {
			bottomGrad: '#8a8a8a 0%,#6c6c6c 15%,#585858 35%,#585858 65%,#6c6c6c 85%,#8a8a8a 100%',
			bottomShadowColor: '#aaaaaa',
			topGrad: '#c1c1c1,#8a8a8a',
			topShadowColor: '#d7d7d7'
		},
		red: {
			bottomGrad: '#c60b21 0%,#a1041f 15%,#7d0806 35%,#7d0806 65%,#a1041f 85%,#c60b21 100%',
			bottomShadowColor: '#ff6360',
			topGrad: '#ff5350,#c60b21',
			topShadowColor: '#ff6360'
		},
		purple: {
			bottomGrad: '#7135b9 0%,#5a2b91 15%,#4d2878 35%,#4d2878 65%,#5a2b91 85%,#7135b9 100%',
			bottomShadowColor: '#9052d9',
			topGrad: '#c380f7,#6c20c3',
			topShadowColor: '#ce97f9'
		},
		yellow: {
			bottomGrad: '#dd903f 0%,#dd7035 15%,#b6541f 35%,#b6541f 65%,#dd7035 85%,#dd903f 100%',
			bottomShadowColor: '#fddd5d',
			topGrad: '#fcc943,#ff9c3c',
			topShadowColor: '#fddd5d',
			//textColor: '#85380b'
		},
		black: {
			bottomGrad: '#2a2a2a 0%,#1c1c1c 15%,#121212 35%,#121212 65%,#1c1c1c 85%,#2a2a2a 100%',
			bottomShadowColor: '#434343',
			topGrad: '#333333,#1a1a1a',
			topShadowColor: '#434343'
		}
	}
}

const WinTrialConstants = {
	remotePath: remoteFolder + '/WEB',
	gleamConfig: remoteFolder + '/WEB/gleamConfig.json',
}
export const Const = {...SiuConstants, ...WinTrialConstants}

